import { render, staticRenderFns } from "./ThinBarChart.vue?vue&type=template&id=75606c2c"
import script from "./ThinBarChart.vue?vue&type=script&lang=js"
export * from "./ThinBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports